"use client";

import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import type { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import {
  getMobileError,
  computeMobileValue,
  getPhoneKeydownOverride,
  type PhoneCountry,
} from "@/src/lib/phoneValidation";

interface FormDataState {
  website: string;
  useragent: string;
  starttime: string;
  enquiry_date: string;
  enquiry_month: string;
  enquiry_time: string;
  ipaddress: string;
}

interface FormFieldsState {
  checkvalue: string;
  name: string;
  email: string;
  mobile: string;
  city: string;
  phk: string;
  message: string;
}

interface ApiResponse {
  status: string;
  message?: string;
}

export default function ContactForm() {

  const [isLoading, setIsLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState<string>("");
  const [formData, setFormData] = useState<FormDataState>({
    website: "",
    useragent: "",
    starttime: "",
    enquiry_date: "",
    enquiry_month: "",
    enquiry_time: "",
    ipaddress: "",
  });

  const [formFields, setFormFields] = useState<FormFieldsState>({
    checkvalue: "",
    name: "",
    email: "",
    mobile: "",
    city: "",
    phk: "",
    message: "",
  });

  const prevCountry = useRef<PhoneCountry | null>({ dialCode: "91", countryCode: "in" });
  const [mobileError, setMobileError] = useState("");
  const [mobileTouched, setMobileTouched] = useState(false);

  const siteKey = "6LdjZf0rAAAAAIm8U6InvO-F-wNCPngxUood5Tjz";

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();

        const now = new Date();
        const optionsDate: Intl.DateTimeFormatOptions = {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        };
        const optionsTime: Intl.DateTimeFormatOptions = {
          timeZone: "Asia/Kolkata",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        };

        const enquiry_date = new Intl.DateTimeFormat("en-GB", optionsDate)
          .format(now)
          .split("/")
          .join("-");
        const enquiry_time = new Intl.DateTimeFormat(
          "en-IN",
          optionsTime
        ).format(now);

        const pad = (n: number) => String(n).padStart(2, "0");
        const starttime = `${now.getFullYear()}-${pad(
          now.getMonth() + 1
        )}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(
          now.getMinutes()
        )}:${pad(now.getSeconds())}`;

        const dateParts = enquiry_date.split("-");
        let enquiry_month = "";
        if (dateParts.length === 3) {
          enquiry_month = `${dateParts[1]}-${dateParts[2]}`;
        }

        setFormData({
          website: "www.pluswilla.com",
          useragent: navigator.userAgent,
          starttime,
          enquiry_date,
          enquiry_time,
          enquiry_month,
          ipaddress: data.ip,
        });
      } catch (err) {
        console.error("Failed to fetch IP:", err);
      }
    };

    fetchIp();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (value: string | null) => {
    setCaptchaValue(value || "");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const mobileValidationError = getMobileError(
      formFields.mobile,
      prevCountry.current
    );
    setMobileError(mobileValidationError);
    if (mobileValidationError) {
      setMobileTouched(true);
      return;
    }

    // if (!captchaValue) {
    //   alert("Please complete the CAPTCHA");
    //   return;
    // }

    const isLocalhost =
      typeof window !== "undefined" &&
      window.location.hostname === "localhost";
       

    if (!isLocalhost && !captchaValue) {
      alert("Please complete the CAPTCHA.");
      return;
    }

    const srd = localStorage.getItem("srd");
    const gad_campaignid = localStorage.getItem("gad_campaignid");

    setIsLoading(true);

    const fullData = {
      ...formFields,
      ...formData,
      "g-recaptcha-response": captchaValue,
      srd,
      gad_campaignid,
    };

    const formBody = new FormData();
    (Object.keys(fullData) as Array<keyof typeof fullData>).forEach((key) => {
      formBody.append(key, String(fullData[key] ?? ""));
    });

    // try {
    //   const response = await fetch(
    //     "https://www.pluswilla.com/send/sendmail.php",
    //     {
    //       method: "POST",
    //       body: formBody,
    //     }
    //   );

     try {
        const domain = window.location.origin;
       
        const response = await fetch(`${domain}/send/sendmail.php`, {
          method: "POST",
          body: formBody,
          
      });


      let result: ApiResponse;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        result = await response.json();
      } else {
        const text = await response.text();
        result = { status: "error", message: text || "Unknown response" };
      }

      if (result.status === "success") {
        localStorage.setItem("srd", "");
        localStorage.setItem("gad_campaignid", "");
        window.location.href = "/thanks";
      } else {
        alert(result.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Form submission failed:", error);
      alert("Network error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="  ">
      <h3
        className="
       text-[22px] leading-[30px]
       sm:text-[24px] sm:leading-[32px]
       md:text-[26px] md:leading-[34px]
        lg:text-[28px] lg:leading-[36px]
         xl:text-[32px] xl:leading-[40px]
           2xl:text-[36px] 2xl:leading-[42px]
             tracking-[-0.04em] mb-[30px] font-[300] text-[#000]">
        To Experience +Willa!
      </h3>

      <form onSubmit={handleSubmit} className="space-y-3">
        {/* Name */}

        <div className="sm:grid flex flex-col sm:grid-cols-2  lg:grid-cols-1 xl:grid-cols-2 gap-[10px] mb-[10px]">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Name*"
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000] "
            />
          </div>
          {/* Email */}
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email*"
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000]"
            />
          </div>

          {/* Mobile Number */}
          <div>
            <PhoneInput
  country="in"
  value={formFields.mobile.replace(/\D/g, "") || ""}
  onChange={(value: string, country: CountryData) => {
    const { formattedValue, dialCode, countryCode, format } = computeMobileValue(
      value,
      country,
      prevCountry.current
    );
    prevCountry.current = { dialCode, countryCode, format };

    setFormFields((prev) => ({
      ...prev,
      mobile: formattedValue,
    }));
    setMobileError(getMobileError(formattedValue, prevCountry.current));
  }}
  placeholder="Mobile number*"
  inputProps={{
    name: "mobile",
    required: true,
    onBlur: () => setMobileTouched(true),
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
      const override = getPhoneKeydownOverride(
        e.currentTarget,
        e.key,
        formFields.mobile,
        prevCountry.current
      );
      if (!override) return;
      e.preventDefault();

      if (override === "block") {
        return;
      }

      const dialCode = prevCountry.current?.dialCode || "";
      const formattedValue = `+${dialCode} ${override.digit}`;
      setFormFields((prev) => ({ ...prev, mobile: formattedValue }));
      setMobileError(getMobileError(formattedValue, prevCountry.current));
    },
  }}
  inputStyle={{
    width: "100%",
    height: "48px",
    backgroundColor: "#D9D9D9",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    paddingLeft: "50px",
    paddingTop: "12px",
    paddingBottom: "12px",
    fontSize: "16px",
    color: "#000",
    outline: "none",
  }}
  buttonStyle={{
    border: "1px solid #d1d5db",
    borderRight: "none",
    borderRadius: "8px 0 0 8px",
    backgroundColor: "#D9D9D9",
  }}
  containerStyle={{
    width: "100%",
  }}
  enableSearch
  countryCodeEditable={false}
  {...({ separateDialCode: true } as Record<string, unknown>)}
/>
            {mobileTouched && mobileError ? (
              <p className="text-red-600 text-xs mt-1">{mobileError}</p>
            ) : null}
            {/* <input
              type="tel"
              name="mobile"
              placeholder="Mobile number*"
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000]"
            /> */}
          </div>
          <div>
            <input
              type="text"
              name="city"
              placeholder="Location*"
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000]"
            />
          </div>
          <div className="col-span-2">
            <select
              name="phk"
              onChange={handleChange}
              defaultValue=""
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000] ">
              <option value="" disabled>
                Looking For *
              </option>
              <option value="3 BHK (1.97 Cr - 2.28 Cr)">
                3 BHK (1.97 Cr - 2.28 Cr)
              </option>
              <option value="4 BHK (2.47 Cr - 2.64 Cr)">
                4 BHK (2.47 Cr - 2.64 Cr)
              </option>
            </select>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-1  lg:grid-cols-1 xl:grid-cols-1 gap-[10px] mb-[10px]">
          {/* Email */}

          {/* Mobile Number */}
          <div>
            <textarea
              name="message"
              placeholder="Message*"
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-[#D9D9D9] border border-gray-300 rounded-lg focus:outline-none text-[#000]"
            />
          </div>
        </div>

        {/* Hidden fields */}
        {(Object.keys(formData) as (keyof FormDataState)[]).map((key) => (
          <input
            key={key}
            type="hidden"
            name={key}
            value={String(formData[key])}
          />
        ))}

        {/* reCAPTCHA */}
        <div className="md:col-span-2  recaptcha">
          <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          data-cta="enq-now"
          className="enq-now   group text-[#fff] hover:text-[#fff] bg-[#000] rounded-[50px] px-[20px] md:px-[25px] py-[8px] md:py-[12px] w-fit gap-[15px] flex
           items-center justify-between transition-all duration-300 hover:bg-[#AF8E43] cursor-pointer" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Enquire Now"}
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="https://www.w3.org/2000/svg"
            className="transition-transform duration-300 group-hover:rotate-45">
            <path
              d="M15.435 1.56497C15.435 1.01269 14.9873 0.564971 14.435 0.564971L5.43503 0.564972C4.88274 0.564971 4.43503 1.01269 4.43503 1.56497C4.43503 2.11726 4.88274 2.56497 5.43503 2.56497L13.435 2.56497L13.435 10.565C13.435 11.1173 13.8827 11.565 14.435 11.565C14.9873 11.565 15.435 11.1173 15.435 10.565L15.435 1.56497ZM1 15L1.70711 15.7071L15.1421 2.27208L14.435 1.56497L13.7279 0.857865L0.292893 14.2929L1 15Z"
              fill="#fff"
              className="group-hover:fill-[#fff]"></path>
          </svg>
        </button>
      </form>
    </section>
  );
}
